import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LivescoreRoutingModule } from './livescore-routing.module';
import { LivescoreComponent } from './livescore/livescore.component';
import { WomensFixtureComponent } from './womens-fixture/womens-fixture.component';


@NgModule({
  declarations: [LivescoreComponent, WomensFixtureComponent],
  imports: [
    CommonModule,
    LivescoreRoutingModule
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class LivescoreModule { }
